import produce from "immer";
import { loginTypes } from "./constants";
import { combineReducers } from "redux";

export const initialState = {
  isLoading: false,
  data: false,
  error: false
};

export const initialRedirect = {
  redirect: false
};

export const StudentLoginReducer = (state = initialState, action = {}) =>
  produce(state, (draft) => {
    switch (action.type) {
      case loginTypes.LOGIN_REQUEST:
        draft.isLoading = true;
        draft.error = false;
        draft.data = false;
        break;
      case loginTypes.LOGIN_SUCCESS:
        draft.data = action.payload;
        draft.isLoading = false;
        break;
      case loginTypes.LOGIN_ERROR:
        draft.error = action.error;
        draft.isLoading = false;
        break;
      case loginTypes.RESET_ERROR:
        draft.error = false;
        draft.isLoading = false;
        break;
      default:
        draft = state;
        break;
    }
  });

export const employeeVerifyReducer = (state = initialState, action = {}) =>
  produce(state, (draft) => {
    switch (action.type) {
      case loginTypes.EMPLOYEE_VERIFY_REQUEST:
        draft.isLoading = true;
        draft.error = false;
        draft.data = false;
        break;
      case loginTypes.EMPLOYEE_VERIFY_SUCCESS:
        draft.data = action.payload;
        draft.isLoading = false;
        break;
      case loginTypes.EMPLOYEE_VERIFY_ERROR:
        draft.error = action.error;
        draft.isLoading = false;
        break;
      case loginTypes.EMPLOYEE_ERROR_RESET:
        draft.error = false;
        break;
      default:
        draft = state;
        break;
    }
  });

export const otpVerifyReducer = (state = initialState, action = {}) =>
  produce(state, (draft) => {
    switch (action.type) {
      case loginTypes.OTP_VERIFY_REQUEST:
        draft.isLoading = true;
        draft.error = false;
        draft.data = false;
        break;
      case loginTypes.OTP_VERIFY_SUCCESS:
        draft.isLoading = false;
        draft.data = action.payload;
        break;
      case loginTypes.OTP_VERIFY_ERROR:
        draft.isLoading = false;
        draft.error = action.error;
        break;
      case loginTypes.OTP_VERIFY_RESET:
        draft.isLoading = false;
        draft.data = false;
        draft.error = false;
        break;
      default:
        draft = state;
        break;
    }
  });

export const logoutReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case loginTypes.LOGOUT_EMPLOYEE_REQUEST:
        draft.isLoading = true;
        draft.error = false;
        draft.data = false;
        break;
      case loginTypes.LOGOUT_EMPLOYEE_SUCCESS:
        draft.isLoading = false;
        draft.data = action.payload;
        break;
      case loginTypes.LOGOUT_EMPLOYEE_ERROR:
        draft.isLoading = true;
        draft.error = action.error;
        break;
      default:
        draft = state;
        break;
    }
  });

export const employeeDetailsReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case loginTypes.GET_EMPLOYEE_DETAILS_REQUEST:
        draft.isLoading = true;
        break;
      case loginTypes.GET_EMPLOYEE_DETAILS_SUCCESS:
        draft.isLoading = false;
        draft.data = action.payload;
        break;
      case loginTypes.GET_EMPLOYEE_DETAILS_ERROR:
        draft.isLoading = false;
        draft.error = action.error;
        break;
      default:
        draft = state;
        break;
    }
  });

export const redirectingReducer = (state = initialRedirect, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case loginTypes.REDIRECTING_TYPE:
        draft.redirect = action.payload;
        break;
      default:
        draft = state;
        break;
    }
  });

const StudentReducer = combineReducers({
  StudentLoginReducer,
  employeeVerifyReducer,
  otpVerifyReducer,
  logoutReducer,
  employeeDetailsReducer,
  redirectingReducer
});

export default StudentReducer;
